<template>
    <div style="text-align: center">
      <div style="width: 90%; text-align: center; margin: 0 auto">
        <p class="title is-4" style="margin-bottom: -5px"> La scheda con i risultati della somministrazione del Lüscher-Test è pronta! <br><br>  </p> 
        <Button @click="download" id="downloadButton" :style="{ fontSize: width < 1100 ? '20px' : '40px'}"> Scarica risultati</Button>
        <br><br>
      </div>
      
      <canvas v-show="width > 1100" id="canvas" style="border: 1px solid grey" @click="download"></canvas>
      <br>
    </div>
  </template>
  
  <script>
  
  export default {
    components: {
    },
    data() {
      return {
        canvas: null,
        width: 1100,
        name: "",
        urlParams: {}
      };
    },
    computed: {
      
    },
    methods: {
      doCanvas() {
  
      },
      buildUrlParams() {
        const url = new URL(window.location.href)
        const params = {}

        // Store params uppercased so Mindstamp can send LS01, ls01, or Ls01.
        url.searchParams.forEach((value, key) => {
          params[key.toUpperCase()] = value
        })

        return params
      },
      param(name, fallback = '') {
        return this.urlParams[name.toUpperCase()] || fallback
      },
      signedValue(sign, variable) {
        const value = this.param(variable)
        return value ? `${sign}${value}` : `${sign}?`
      },
      plainValue(variable) {
        return this.param(variable) || '?'
      },
      formatSignedSequence(items) {
        return items
          .map(([sign, variable]) => sign ? this.signedValue(sign, variable) : this.plainValue(variable))
          .join(' ')
      },
      countLuscherValues(variables) {
        const counts = { 1: 0, 2: 0, 3: 0, 4: 0 }

        variables.forEach((variable) => {
          const value = this.param(variable)
          if (Object.prototype.hasOwnProperty.call(counts, value)) {
            counts[value] += 1
          }
        })

        return counts
      },
      hasCompleteLuscherSelections(variables) {
        return variables.every((variable) => {
          const value = this.param(variable)
          return ['1', '2', '3', '4'].includes(value)
        })
      },
      luscherOutputFromSelections(variables) {
        const counts = this.countLuscherValues(variables)

        // Same display rule as Mindscript: frequency buckets 3, 2, 1, then 0.
        return [3, 2, 1, 0].map((frequency) => {
          const bucket = ['1', '2', '3', '4']
            .filter((value) => counts[value] === frequency)
            .join('')

          return bucket || '/'
        }).join(' ')
      },
      luscherOutput(outputVariable, fallbackVariables) {
        if (this.hasCompleteLuscherSelections(fallbackVariables)) {
          return this.luscherOutputFromSelections(fallbackVariables)
        }
        return this.param(outputVariable) || this.luscherOutputFromSelections(fallbackVariables)
      },
      reportLines() {
        return [
          {
            prefix: '[DATA]',
            value: this.param('ADMINISTERED_AT') || this.formattedToday()
          },
          {
            prefix: '[GRIGI]',
            value: this.formatSignedSequence([
              ['+', 'LS01'],
              ['+', 'LS02'],
              ['-', 'LS03']
            ])
          },
          {
            prefix: '[COLORI 1]',
            value: this.formatSignedSequence([
              ['+', 'LS04'],
              ['+', 'LS05'],
              ['', 'LS06'],
              ['', 'LS07'],
              ['', 'LS08'],
              ['-', 'LS09'],
              ['-', 'LS10'],
              ['', 'LS11']
            ])
          },
          {
            prefix: '[COLORI 2]',
            value: this.formatSignedSequence([
              ['+', 'LS46'],
              ['+', 'LS47'],
              ['', 'LS48'],
              ['', 'LS49'],
              ['', 'LS50'],
              ['-', 'LS51'],
              ['-', 'LS52'],
              ['', 'LS53']
            ])
          },
          {
            prefix: '[COMB]',
            value: 'Comb. ' + this.signedValue('+', 'LS54')
          },
          {
            prefix: '[FORME]',
            value: this.formatSignedSequence([
              ['+', 'LS12'],
              ['+', 'LS13'],
              ['-', 'LS14'],
              ['-', 'LS15']
            ])
          },
          {
            prefix: '[FONDAMENTALI]',
            value: this.luscherOutput('LS_OUT_T4', ['LS16', 'LS17', 'LS18', 'LS19', 'LS20', 'LS21'])
          },
          {
            prefix: '[BLU]',
            value: this.luscherOutput('LS_OUT_T5', ['LS22', 'LS23', 'LS24', 'LS25', 'LS26', 'LS27'])
          },
          {
            prefix: '[VERDE]',
            value: this.luscherOutput('LS_OUT_T6', ['LS28', 'LS29', 'LS30', 'LS31', 'LS32', 'LS33'])
          },
          {
            prefix: '[ROSSO]',
            value: this.luscherOutput('LS_OUT_T7', ['LS34', 'LS35', 'LS36', 'LS37', 'LS38', 'LS39'])
          },
          {
            prefix: '[GIALLO]',
            value: this.luscherOutput('LS_OUT_T8', ['LS40', 'LS41', 'LS42', 'LS43', 'LS44', 'LS45'])
          }
        ]
      },
      formattedToday() {
        const today = new Date();
        const yyyy = today.getFullYear();
        const mm = String(today.getMonth() + 1).padStart(2, '0');
        const dd = String(today.getDate()).padStart(2, '0');

        return `${dd}/${mm}/${yyyy}`;
      },
      fillSpacedText(ctx, text, x, y, letterSpacing = 1.2) {
        // Canvas letterSpacing is not consistently supported, so draw manually.
        let currentX = x;

        text.toString().split('').forEach((char) => {
          ctx.fillText(char, currentX, y);
          currentX += ctx.measureText(char).width + letterSpacing;
        });
      },
      drawReportLines(ctx) {
        ctx.fillStyle = "#000000";

        const positions = [
          [465, 286],
          [380, 448],
          [390, 504],
          [190, 660],
          [190, 610],
          [410, 722],
          [563, 872],
          [540, 926],
          [563, 981],
          [563, 1035],
          [563, 1090]
        ];

        this.reportLines().forEach((line, index) => {
          const [x, y] = positions[index];
          ctx.font = index === 0 ? "italic 24px Arial" : "28px Arial normal";
          const letterSpacing = index === 0 ? 3.4 : 1.2;
          // ctx.fillText(`${line.prefix} ${line.value}`, x, y);
          this.fillSpacedText(ctx, line.value, x, y, letterSpacing);
        });
      },
      download() {
        var link = document.createElement('a');
        link.href = this.canvas.toDataURL('image/jpeg');
        link.download = this.getUrlParam('name') + ' Certificate.png'
        link.style.display = 'none';
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
      },
      getUrlParam: function (str) {
        return this.param(str)
      },
    },
    mounted() {
      console.log("Mounted")
      this.urlParams = this.buildUrlParams()
      this.width = window.innerWidth;
      var canvas = document.getElementById("canvas")
      this.canvas = canvas
      var ctx = canvas.getContext("2d");
      
      console.log(window.innerWidth)
      // var ratio = 850 / 1100
      // var w = Math.min(1100, window.innerWidth * 0.9)
      // canvas.width = w
      // var h = ratio * w
      // canvas.height = h
      // console.log(w, h)
      // canvas.width = 1000 // 1176
      // canvas.height = 707 // 1346
  
  
      var background = new Image();
      background.src = "https://mindstamp-resources.s3.us-west-2.amazonaws.com/clients/libero/viviana-1.png";
      background.crossOrigin="anonymous"
      var img = background
      // Make sure the image is loaded first otherwise nothing will draw.
      background.onload = ()=>
      {
        canvas.width = img.naturalWidth
        canvas.height = img.naturalHeight
        ctx = canvas.getContext("2d");
        ctx.imageSmoothingQuality = "high";
        ctx.drawImage(img, 0, 0, img.width,    img.height, 0, 0, canvas.width, canvas.height);
        // ctx.globalCompositeOperation='destination-under';
        // ctx.fillStyle = "#253f8e";
       
  
        this.drawReportLines(ctx)

        // ctx.font = "bold 48px Arial";
        // var name = (this.getUrlParam("name") || "").toUpperCase()
        // var text = ctx.measureText(name)
        // console.log(text)
        // ctx.fillText(name, 465, 330);

  
        // ctx.font = "bold 50px Arial";
        // const d = new Date();
        // // Format: dd/mm/yy
        // const pad = n => n.toString().padStart(2, '0');
        // var date = `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear().toString().slice(-2)}`;
        // var text = ctx.measureText(date)
        // ctx.fillText(date, (canvas.width / 2) +- text.width / 2 + 335, (canvas.height / 3) + 18);
      }
  
  
        // ctx.font = "bold 120px Arial";
        // ctx.fillStyle = "white"
        // var name = (this.getUrlParam("event_pdhours") || "").toUpperCase()
        // var text = ctx.measureText(name)
        // console.log(text)
        // ctx.fillText(name, (canvas.width / 2) - (text.width/2) + 495, (canvas.height - 315));
  
  
    },
  };
  </script>
  
  <style scoped lang="scss">
    canvas {
      background-size: 100% 100%;
      cursor: pointer;
      max-width: 90vw;
      max-height: 90vh;
      margin: 0 auto;
    }
  
    #app {
      text-align: center
    }
  
    #downloadButton {
      background: #1e6eb0;
      color: white;
      width: auto;
      height: auto;
      padding: 15px 25px;
      border: 1px solid white;
      border-radius: 10px;
      font-size: 24px;
      cursor: pointer;
  
    }
  </style>
